export const FETCH_ARTICLES_RETREAT_REQUEST = 'FETCH_ARTICLES_RETREAT_REQUEST';
export const FETCH_ARTICLES_RETREAT_SUCCESS = 'FETCH_ARTICLES_RETREAT_SUCCESS';
export const FETCH_ARTICLES_RETREAT_FAILURE = 'FETCH_ARTICLES_RETREAT_FAILURE';
export const FETCH_ARTICLES_RETREAT_CLEAN_UP =
    'FETCH_ARTICLES_RETREAT_CLEAN_UP';
export const UPDATE_RETREAT_PAGE_START_PARAM =
    'UPDATE_RETREAT_PAGE_START_PARAM';
